<script type="text/jsx">
import UiTextButton from './UiTextButton';
import Icon from 'common/UIToolKit/Icon.vue';

export default {
    functional: true,
    components: { UiTextButton },
    render(h, { data }) {
        data.class = { 'modal-close-button absolute w-10 h-10 top-0 right-0 text-elephant z-1000': true, ...data.class };

        return <UiTextButton {...data}>
            <Icon for="cross" class="sml"></Icon>
        </UiTextButton>;
    },
};
</script>
